import { render, staticRenderFns } from "./articleInfo.vue?vue&type=template&id=a053664c&scoped=true&"
import script from "./articleInfo.vue?vue&type=script&lang=js&"
export * from "./articleInfo.vue?vue&type=script&lang=js&"
import style0 from "./articleInfo.vue?vue&type=style&index=0&id=a053664c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a053664c",
  null
  
)

export default component.exports